module.exports = __webpack_public_path__ + "Roboto-Thin.cc85ce37b4256966e6f3.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Thin.ttf
// module id = 327
// module chunks = 19